import * as React from 'react';
import { Tile } from '../../../models/Mahjong';
import { TileImage } from './TileImage';

interface DiscardPileProps {
    tiles: Tile[];
    tileHeight?: number;
}

export function DiscardPile({ tiles, tileHeight }: DiscardPileProps): JSX.Element {
    const h = tileHeight ?? 40;
    const w = h * (44 / 60);

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(6, ${w}px)`,
            gap: '2px',
            justifyContent: 'start'
        }}>
            {tiles.map((tile) => (
                <TileImage key={tile.id} tile={tile} height={h} />
            ))}
        </div>
    );
}
